@file:OptIn(InternalResourceApi::class)

package gamerlogue.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gamerlogue.sharedui.generated.resources/"

@delegate:ResourceContentHash(1_941_095_790)
internal val Res.string.nav__library: StringResource by lazy {
      StringResource("string:nav__library", "nav__library", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23640, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22064, 32),
      ))
    }

@delegate:ResourceContentHash(-1_447_242_804)
internal val Res.string.nav__notifications: StringResource by lazy {
      StringResource("string:nav__notifications", "nav__notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23673, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22097, 46),
      ))
    }

@delegate:ResourceContentHash(-1_570_369_502)
internal val Res.string.nav__profile: StringResource by lazy {
      StringResource("string:nav__profile", "nav__profile", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23712, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22144, 32),
      ))
    }

@delegate:ResourceContentHash(-1_407_042_235)
internal val Res.string.nav__settings: StringResource by lazy {
      StringResource("string:nav__settings", "nav__settings", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23745, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22177, 33),
      ))
    }

@delegate:ResourceContentHash(-1_247_251_185)
internal val Res.string.notifications__comment_reacted: StringResource by lazy {
      StringResource("string:notifications__comment_reacted", "notifications__comment_reacted", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23783, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22211, 82),
      ))
    }

@delegate:ResourceContentHash(-1_724_767_001)
internal val Res.string.notifications__comment_replied: StringResource by lazy {
      StringResource("string:notifications__comment_replied", "notifications__comment_replied", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23870, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22294, 74),
      ))
    }

@delegate:ResourceContentHash(-879_161_042)
internal val Res.string.notifications__empty: StringResource by lazy {
      StringResource("string:notifications__empty", "notifications__empty", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23949, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22369, 52),
      ))
    }

@delegate:ResourceContentHash(1_239_584_318)
internal val Res.string.notifications__list_commented: StringResource by lazy {
      StringResource("string:notifications__list_commented", "notifications__list_commented", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24002, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22422, 73),
      ))
    }

@delegate:ResourceContentHash(1_794_706_075)
internal val Res.string.notifications__list_liked: StringResource by lazy {
      StringResource("string:notifications__list_liked", "notifications__list_liked", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24084, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22496, 61),
      ))
    }

@delegate:ResourceContentHash(275_484_646)
internal val Res.string.notifications__mark_all_read: StringResource by lazy {
      StringResource("string:notifications__mark_all_read", "notifications__mark_all_read", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24154, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22558, 56),
      ))
    }

@delegate:ResourceContentHash(-41_617_499)
internal val Res.string.notifications__new_follower: StringResource by lazy {
      StringResource("string:notifications__new_follower", "notifications__new_follower", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24223, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22615, 71),
      ))
    }

@delegate:ResourceContentHash(-238_292_430)
internal val Res.string.notifications__review_commented: StringResource by lazy {
      StringResource("string:notifications__review_commented", "notifications__review_commented", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24295, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22687, 79),
      ))
    }

@delegate:ResourceContentHash(-1_454_771_679)
internal val Res.string.notifications__review_liked: StringResource by lazy {
      StringResource("string:notifications__review_liked", "notifications__review_liked", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24383, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22767, 67),
      ))
    }

@delegate:ResourceContentHash(516_331_316)
internal val Res.string.notifications__unknown: StringResource by lazy {
      StringResource("string:notifications__unknown", "notifications__unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24459, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22835, 62),
      ))
    }

@delegate:ResourceContentHash(-534_867_268)
internal val Res.string.player_perspective__auditory: StringResource by lazy {
      StringResource("string:player_perspective__auditory", "player_perspective__auditory", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24522, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22898, 48),
      ))
    }

@delegate:ResourceContentHash(141_540_006)
internal val Res.string.player_perspective__first_person: StringResource by lazy {
      StringResource("string:player_perspective__first_person", "player_perspective__first_person", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24579, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22947, 56),
      ))
    }

@delegate:ResourceContentHash(-1_676_727_158)
internal val Res.string.player_perspective__isometric: StringResource by lazy {
      StringResource("string:player_perspective__isometric", "player_perspective__isometric", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24640, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23004, 65),
      ))
    }

@delegate:ResourceContentHash(342_459_030)
internal val Res.string.player_perspective__side_view: StringResource by lazy {
      StringResource("string:player_perspective__side_view", "player_perspective__side_view", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24718, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23070, 49),
      ))
    }

@delegate:ResourceContentHash(2_010_050_644)
internal val Res.string.player_perspective__text: StringResource by lazy {
      StringResource("string:player_perspective__text", "player_perspective__text", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24800, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23120, 40),
      ))
    }

@delegate:ResourceContentHash(276_749_731)
internal val Res.string.player_perspective__third_person: StringResource by lazy {
      StringResource("string:player_perspective__third_person", "player_perspective__third_person", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24845, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23161, 56),
      ))
    }

@delegate:ResourceContentHash(-987_315_395)
internal val Res.string.player_perspective__unknown: StringResource by lazy {
      StringResource("string:player_perspective__unknown", "player_perspective__unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24906, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23218, 63),
      ))
    }

@delegate:ResourceContentHash(-286_341_114)
internal val Res.string.player_perspective__virtual_reality: StringResource by lazy {
      StringResource("string:player_perspective__virtual_reality", "player_perspective__virtual_reality", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 24974, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23282, 63),
      ))
    }

@delegate:ResourceContentHash(2_023_978_615)
internal val Res.string.profile__activity_empty: StringResource by lazy {
      StringResource("string:profile__activity_empty", "profile__activity_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25046, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23346, 55),
      ))
    }

@delegate:ResourceContentHash(1_259_528_992)
internal val Res.string.profile__banner: StringResource by lazy {
      StringResource("string:profile__banner", "profile__banner", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25313, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23581, 31),
      ))
    }

@delegate:ResourceContentHash(-945_544_978)
internal val Res.string.profile__banner_choose: StringResource by lazy {
      StringResource("string:profile__banner_choose", "profile__banner_choose", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25114, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23402, 50),
      ))
    }

@delegate:ResourceContentHash(1_397_916_266)
internal val Res.string.profile__banner_hint: StringResource by lazy {
      StringResource("string:profile__banner_hint", "profile__banner_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25169, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23453, 88),
      ))
    }

@delegate:ResourceContentHash(-245_963_651)
internal val Res.string.profile__banner_remove: StringResource by lazy {
      StringResource("string:profile__banner_remove", "profile__banner_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25270, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23542, 38),
      ))
    }

@delegate:ResourceContentHash(80_681_152)
internal val Res.string.profile__bio: StringResource by lazy {
      StringResource("string:profile__bio", "profile__bio", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25345, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23613, 24),
      ))
    }

@delegate:ResourceContentHash(-159_318_544)
internal val Res.string.profile__block: StringResource by lazy {
      StringResource("string:profile__block", "profile__block", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25873, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24129, 30),
      ))
    }

@delegate:ResourceContentHash(597_632_695)
internal val Res.string.profile__block_confirm_message: StringResource by lazy {
      StringResource("string:profile__block_confirm_message", "profile__block_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25370, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23638, 166),
      ))
    }

@delegate:ResourceContentHash(-1_868_217_160)
internal val Res.string.profile__block_confirm_title: StringResource by lazy {
      StringResource("string:profile__block_confirm_title", "profile__block_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25541, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23805, 60),
      ))
    }

@delegate:ResourceContentHash(-1_908_700_611)
internal val Res.string.profile__blocked: StringResource by lazy {
      StringResource("string:profile__blocked", "profile__blocked", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25816, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24076, 52),
      ))
    }

@delegate:ResourceContentHash(-1_397_143_087)
internal val Res.string.profile__blocked_hint: StringResource by lazy {
      StringResource("string:profile__blocked_hint", "profile__blocked_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25610, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23866, 85),
      ))
    }

@delegate:ResourceContentHash(585_679_411)
internal val Res.string.profile__blocked_users: StringResource by lazy {
      StringResource("string:profile__blocked_users", "profile__blocked_users", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25765, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24025, 50),
      ))
    }

@delegate:ResourceContentHash(633_042_696)
internal val Res.string.profile__blocked_users_empty: StringResource by lazy {
      StringResource("string:profile__blocked_users_empty", "profile__blocked_users_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25692, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23952, 72),
      ))
    }

@delegate:ResourceContentHash(-1_214_337_405)
internal val Res.string.profile__edit: StringResource by lazy {
      StringResource("string:profile__edit", "profile__edit", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26070, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24290, 37),
      ))
    }

@delegate:ResourceContentHash(2_103_259_754)
internal val Res.string.profile__edit_invalid: StringResource by lazy {
      StringResource("string:profile__edit_invalid", "profile__edit_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 25904, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24160, 129),
      ))
    }

@delegate:ResourceContentHash(1_519_043_379)
internal val Res.string.profile__first_name: StringResource by lazy {
      StringResource("string:profile__first_name", "profile__first_name", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26116, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24328, 43),
      ))
    }

@delegate:ResourceContentHash(1_062_793_530)
internal val Res.string.profile__follow: StringResource by lazy {
      StringResource("string:profile__follow", "profile__follow", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26271, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24495, 31),
      ))
    }

@delegate:ResourceContentHash(-180_573_924)
internal val Res.string.profile__followers: StringResource by lazy {
      StringResource("string:profile__followers", "profile__followers", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26152, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24372, 38),
      ))
    }

@delegate:ResourceContentHash(1_057_688_359)
internal val Res.string.profile__following: StringResource by lazy {
      StringResource("string:profile__following", "profile__following", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26191, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24411, 38),
      ))
    }

@delegate:ResourceContentHash(-1_392_399_225)
internal val Res.string.profile__follows_you: StringResource by lazy {
      StringResource("string:profile__follows_you", "profile__follows_you", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26230, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24450, 44),
      ))
    }

@delegate:ResourceContentHash(-807_483_905)
internal val Res.string.profile__last_name: StringResource by lazy {
      StringResource("string:profile__last_name", "profile__last_name", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26303, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24527, 38),
      ))
    }

@delegate:ResourceContentHash(1_052_531_087)
internal val Res.string.profile__library_empty: StringResource by lazy {
      StringResource("string:profile__library_empty", "profile__library_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26342, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24566, 58),
      ))
    }

@delegate:ResourceContentHash(-924_672_275)
internal val Res.string.profile__load_error: StringResource by lazy {
      StringResource("string:profile__load_error", "profile__load_error", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26401, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24625, 63),
      ))
    }

@delegate:ResourceContentHash(331_127_552)
internal val Res.string.profile__nickname: StringResource by lazy {
      StringResource("string:profile__nickname", "profile__nickname", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26585, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24789, 37),
      ))
    }

@delegate:ResourceContentHash(529_967_543)
internal val Res.string.profile__nickname_rules: StringResource by lazy {
      StringResource("string:profile__nickname_rules", "profile__nickname_rules", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26473, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24689, 99),
      ))
    }

@delegate:ResourceContentHash(-354_362_549)
internal val Res.string.profile__picture_edit: StringResource by lazy {
      StringResource("string:profile__picture_edit", "profile__picture_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26623, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24827, 49),
      ))
    }

@delegate:ResourceContentHash(-946_964_425)
internal val Res.string.profile__picture_hint: StringResource by lazy {
      StringResource("string:profile__picture_hint", "profile__picture_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26669, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24877, 125),
      ))
    }

@delegate:ResourceContentHash(767_702_818)
internal val Res.string.profile__picture_provider_only: StringResource by lazy {
      StringResource("string:profile__picture_provider_only", "profile__picture_provider_only", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26779, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25003, 110),
      ))
    }

@delegate:ResourceContentHash(-1_263_405_668)
internal val Res.string.profile__platforms: StringResource by lazy {
      StringResource("string:profile__platforms", "profile__platforms", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27192, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25400, 38),
      ))
    }

@delegate:ResourceContentHash(-2_114_443_183)
internal val Res.string.profile__platforms_edit: StringResource by lazy {
      StringResource("string:profile__platforms_edit", "profile__platforms_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26878, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25114, 55),
      ))
    }

@delegate:ResourceContentHash(-1_058_231_678)
internal val Res.string.profile__platforms_hint: StringResource by lazy {
      StringResource("string:profile__platforms_hint", "profile__platforms_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 26938, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25170, 171),
      ))
    }

@delegate:ResourceContentHash(-814_495_366)
internal val Res.string.profile__platforms_search: StringResource by lazy {
      StringResource("string:profile__platforms_search", "profile__platforms_search", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27130, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25342, 57),
      ))
    }

@delegate:ResourceContentHash(-91_434_102)
internal val Res.string.profile__private: StringResource by lazy {
      StringResource("string:profile__private", "profile__private", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27580, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25760, 44),
      ))
    }

@delegate:ResourceContentHash(616_860_158)
internal val Res.string.profile__private_hint: StringResource by lazy {
      StringResource("string:profile__private_hint", "profile__private_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27414, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25614, 93),
      ))
    }

@delegate:ResourceContentHash(-1_697_444_401)
internal val Res.string.profile__private_hint_edit: StringResource by lazy {
      StringResource("string:profile__private_hint_edit", "profile__private_hint_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27235, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25439, 174),
      ))
    }

@delegate:ResourceContentHash(-91_434_102)
internal val Res.string.profile__private_switch: StringResource by lazy {
      StringResource("string:profile__private_switch", "profile__private_switch", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27528, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25708, 51),
      ))
    }

@delegate:ResourceContentHash(-1_993_585_557)
internal val Res.string.profile__report: StringResource by lazy {
      StringResource("string:profile__report", "profile__report", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27625, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25805, 31),
      ))
    }

@delegate:ResourceContentHash(1_101_010_681)
internal val Res.string.profile__reviews_empty: StringResource by lazy {
      StringResource("string:profile__reviews_empty", "profile__reviews_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27661, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25837, 50),
      ))
    }

@delegate:ResourceContentHash(313_676_757)
internal val Res.string.profile__save: StringResource by lazy {
      StringResource("string:profile__save", "profile__save", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27728, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25888, 29),
      ))
    }

@delegate:ResourceContentHash(-1_634_698_005)
internal val Res.string.profile__search_users: StringResource by lazy {
      StringResource("string:profile__search_users", "profile__search_users", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27758, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25918, 45),
      ))
    }

@delegate:ResourceContentHash(1_866_462_128)
internal val Res.string.profile__subtitle: StringResource by lazy {
      StringResource("string:profile__subtitle", "profile__subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27804, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25964, 61),
      ))
    }

@delegate:ResourceContentHash(1_277_006_744)
internal val Res.string.profile__tab_activity: StringResource by lazy {
      StringResource("string:profile__tab_activity", "profile__tab_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27874, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26026, 41),
      ))
    }

@delegate:ResourceContentHash(1_941_095_790)
internal val Res.string.profile__tab_library: StringResource by lazy {
      StringResource("string:profile__tab_library", "profile__tab_library", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27916, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26068, 40),
      ))
    }

@delegate:ResourceContentHash(499_720_265)
internal val Res.string.profile__tab_lists: StringResource by lazy {
      StringResource("string:profile__tab_lists", "profile__tab_lists", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27957, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26109, 34),
      ))
    }

@delegate:ResourceContentHash(879_033_611)
internal val Res.string.profile__tab_reviews: StringResource by lazy {
      StringResource("string:profile__tab_reviews", "profile__tab_reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 27992, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26144, 40),
      ))
    }

@delegate:ResourceContentHash(719_829_396)
internal val Res.string.profile__tab_stats: StringResource by lazy {
      StringResource("string:profile__tab_stats", "profile__tab_stats", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28037, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26185, 34),
      ))
    }

@delegate:ResourceContentHash(-946_892_841)
internal val Res.string.profile__unblock: StringResource by lazy {
      StringResource("string:profile__unblock", "profile__unblock", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28080, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26220, 36),
      ))
    }

@delegate:ResourceContentHash(-1_237_583_464)
internal val Res.string.profile__unfollow: StringResource by lazy {
      StringResource("string:profile__unfollow", "profile__unfollow", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28117, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26257, 37),
      ))
    }

@delegate:ResourceContentHash(-1_083_460_475)
internal val Res.string.reactions__add: StringResource by lazy {
      StringResource("string:reactions__add", "reactions__add", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28167, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26295, 42),
      ))
    }

@delegate:ResourceContentHash(-826_419_988)
internal val Res.string.reactions__pause: StringResource by lazy {
      StringResource("string:reactions__pause", "reactions__pause", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28218, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26338, 52),
      ))
    }

@delegate:ResourceContentHash(979_702_629)
internal val Res.string.reactions__play: StringResource by lazy {
      StringResource("string:reactions__play", "reactions__play", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28283, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26391, 51),
      ))
    }

@delegate:ResourceContentHash(409_554_148)
internal val Res.string.reactions__rejected: StringResource by lazy {
      StringResource("string:reactions__rejected", "reactions__rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28339, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26443, 83),
      ))
    }

@delegate:ResourceContentHash(147_587_727)
internal val Res.string.reactions__search: StringResource by lazy {
      StringResource("string:reactions__search", "reactions__search", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28427, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26527, 45),
      ))
    }

@delegate:ResourceContentHash(439_406_624)
internal val Res.string.region__asia: StringResource by lazy {
      StringResource("string:region__asia", "region__asia", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28477, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26573, 28),
      ))
    }

@delegate:ResourceContentHash(-684_608)
internal val Res.string.region__australia: StringResource by lazy {
      StringResource("string:region__australia", "region__australia", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28506, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26602, 37),
      ))
    }

@delegate:ResourceContentHash(-436_067_678)
internal val Res.string.region__brazil: StringResource by lazy {
      StringResource("string:region__brazil", "region__brazil", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28544, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26640, 30),
      ))
    }

@delegate:ResourceContentHash(1_014_827_434)
internal val Res.string.region__china: StringResource by lazy {
      StringResource("string:region__china", "region__china", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28579, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26671, 29),
      ))
    }

@delegate:ResourceContentHash(-612_471_804)
internal val Res.string.region__europe: StringResource by lazy {
      StringResource("string:region__europe", "region__europe", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28609, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26701, 30),
      ))
    }

@delegate:ResourceContentHash(-1_488_392_214)
internal val Res.string.region__japan: StringResource by lazy {
      StringResource("string:region__japan", "region__japan", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28640, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26732, 29),
      ))
    }

@delegate:ResourceContentHash(965_542_014)
internal val Res.string.region__korea: StringResource by lazy {
      StringResource("string:region__korea", "region__korea", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28674, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26762, 29),
      ))
    }

@delegate:ResourceContentHash(-1_947_194_256)
internal val Res.string.region__new_zealand: StringResource by lazy {
      StringResource("string:region__new_zealand", "region__new_zealand", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28704, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26792, 43),
      ))
    }

@delegate:ResourceContentHash(1_249_628_275)
internal val Res.string.region__north_america: StringResource by lazy {
      StringResource("string:region__north_america", "region__north_america", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28752, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26836, 49),
      ))
    }

@delegate:ResourceContentHash(1_919_342_494)
internal val Res.string.region__unknown: StringResource by lazy {
      StringResource("string:region__unknown", "region__unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28798, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26886, 35),
      ))
    }

@delegate:ResourceContentHash(807_628_299)
internal val Res.string.region__worldwide: StringResource by lazy {
      StringResource("string:region__worldwide", "region__worldwide", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28838, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26922, 37),
      ))
    }

@delegate:ResourceContentHash(280_007_170)
internal val Res.string.report__note: StringResource by lazy {
      StringResource("string:report__note", "report__note", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28884, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26960, 44),
      ))
    }

@delegate:ResourceContentHash(-432_866_456)
internal val Res.string.report__reason_harassment: StringResource by lazy {
      StringResource("string:report__reason_harassment", "report__reason_harassment", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28937, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27005, 49),
      ))
    }

@delegate:ResourceContentHash(1_674_240_894)
internal val Res.string.report__reason_hate: StringResource by lazy {
      StringResource("string:report__reason_hate", "report__reason_hate", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 28983, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27055, 43),
      ))
    }

@delegate:ResourceContentHash(-791_531_783)
internal val Res.string.report__reason_impersonation: StringResource by lazy {
      StringResource("string:report__reason_impersonation", "report__reason_impersonation", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29039, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27099, 56),
      ))
    }

@delegate:ResourceContentHash(-1_556_633_648)
internal val Res.string.report__reason_inappropriate: StringResource by lazy {
      StringResource("string:report__reason_inappropriate", "report__reason_inappropriate", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29100, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27156, 64),
      ))
    }

@delegate:ResourceContentHash(-1_935_960_031)
internal val Res.string.report__reason_other: StringResource by lazy {
      StringResource("string:report__reason_other", "report__reason_other", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29169, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27221, 36),
      ))
    }

@delegate:ResourceContentHash(-988_041_632)
internal val Res.string.report__reason_spam: StringResource by lazy {
      StringResource("string:report__reason_spam", "report__reason_spam", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29206, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27258, 35),
      ))
    }

@delegate:ResourceContentHash(591_049_391)
internal val Res.string.report__reason_spoiler: StringResource by lazy {
      StringResource("string:report__reason_spoiler", "report__reason_spoiler", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29242, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27294, 54),
      ))
    }

@delegate:ResourceContentHash(441_004_116)
internal val Res.string.report__send: StringResource by lazy {
      StringResource("string:report__send", "report__send", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29301, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27349, 28),
      ))
    }

@delegate:ResourceContentHash(435_016_889)
internal val Res.string.report__sent: StringResource by lazy {
      StringResource("string:report__sent", "report__sent", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29330, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27378, 60),
      ))
    }

@delegate:ResourceContentHash(-1_993_585_557)
internal val Res.string.report__title: StringResource by lazy {
      StringResource("string:report__title", "report__title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29407, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27439, 29),
      ))
    }

@delegate:ResourceContentHash(-1_278_282_231)
internal val Res.string.review__not_available: StringResource by lazy {
      StringResource("string:review__not_available", "review__not_available", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29441, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27469, 69),
      ))
    }

@delegate:ResourceContentHash(-406_311_696)
internal val Res.string.review__title: StringResource by lazy {
      StringResource("string:review__title", "review__title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29523, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27539, 29),
      ))
    }

@delegate:ResourceContentHash(-406_202_717)
internal val Res.string.review_aspect__audio: StringResource by lazy {
      StringResource("string:review_aspect__audio", "review_aspect__audio", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29561, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27569, 48),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("nav__library", Res.string.nav__library)
  map.put("nav__notifications", Res.string.nav__notifications)
  map.put("nav__profile", Res.string.nav__profile)
  map.put("nav__settings", Res.string.nav__settings)
  map.put("notifications__comment_reacted", Res.string.notifications__comment_reacted)
  map.put("notifications__comment_replied", Res.string.notifications__comment_replied)
  map.put("notifications__empty", Res.string.notifications__empty)
  map.put("notifications__list_commented", Res.string.notifications__list_commented)
  map.put("notifications__list_liked", Res.string.notifications__list_liked)
  map.put("notifications__mark_all_read", Res.string.notifications__mark_all_read)
  map.put("notifications__new_follower", Res.string.notifications__new_follower)
  map.put("notifications__review_commented", Res.string.notifications__review_commented)
  map.put("notifications__review_liked", Res.string.notifications__review_liked)
  map.put("notifications__unknown", Res.string.notifications__unknown)
  map.put("player_perspective__auditory", Res.string.player_perspective__auditory)
  map.put("player_perspective__first_person", Res.string.player_perspective__first_person)
  map.put("player_perspective__isometric", Res.string.player_perspective__isometric)
  map.put("player_perspective__side_view", Res.string.player_perspective__side_view)
  map.put("player_perspective__text", Res.string.player_perspective__text)
  map.put("player_perspective__third_person", Res.string.player_perspective__third_person)
  map.put("player_perspective__unknown", Res.string.player_perspective__unknown)
  map.put("player_perspective__virtual_reality", Res.string.player_perspective__virtual_reality)
  map.put("profile__activity_empty", Res.string.profile__activity_empty)
  map.put("profile__banner", Res.string.profile__banner)
  map.put("profile__banner_choose", Res.string.profile__banner_choose)
  map.put("profile__banner_hint", Res.string.profile__banner_hint)
  map.put("profile__banner_remove", Res.string.profile__banner_remove)
  map.put("profile__bio", Res.string.profile__bio)
  map.put("profile__block", Res.string.profile__block)
  map.put("profile__block_confirm_message", Res.string.profile__block_confirm_message)
  map.put("profile__block_confirm_title", Res.string.profile__block_confirm_title)
  map.put("profile__blocked", Res.string.profile__blocked)
  map.put("profile__blocked_hint", Res.string.profile__blocked_hint)
  map.put("profile__blocked_users", Res.string.profile__blocked_users)
  map.put("profile__blocked_users_empty", Res.string.profile__blocked_users_empty)
  map.put("profile__edit", Res.string.profile__edit)
  map.put("profile__edit_invalid", Res.string.profile__edit_invalid)
  map.put("profile__first_name", Res.string.profile__first_name)
  map.put("profile__follow", Res.string.profile__follow)
  map.put("profile__followers", Res.string.profile__followers)
  map.put("profile__following", Res.string.profile__following)
  map.put("profile__follows_you", Res.string.profile__follows_you)
  map.put("profile__last_name", Res.string.profile__last_name)
  map.put("profile__library_empty", Res.string.profile__library_empty)
  map.put("profile__load_error", Res.string.profile__load_error)
  map.put("profile__nickname", Res.string.profile__nickname)
  map.put("profile__nickname_rules", Res.string.profile__nickname_rules)
  map.put("profile__picture_edit", Res.string.profile__picture_edit)
  map.put("profile__picture_hint", Res.string.profile__picture_hint)
  map.put("profile__picture_provider_only", Res.string.profile__picture_provider_only)
  map.put("profile__platforms", Res.string.profile__platforms)
  map.put("profile__platforms_edit", Res.string.profile__platforms_edit)
  map.put("profile__platforms_hint", Res.string.profile__platforms_hint)
  map.put("profile__platforms_search", Res.string.profile__platforms_search)
  map.put("profile__private", Res.string.profile__private)
  map.put("profile__private_hint", Res.string.profile__private_hint)
  map.put("profile__private_hint_edit", Res.string.profile__private_hint_edit)
  map.put("profile__private_switch", Res.string.profile__private_switch)
  map.put("profile__report", Res.string.profile__report)
  map.put("profile__reviews_empty", Res.string.profile__reviews_empty)
  map.put("profile__save", Res.string.profile__save)
  map.put("profile__search_users", Res.string.profile__search_users)
  map.put("profile__subtitle", Res.string.profile__subtitle)
  map.put("profile__tab_activity", Res.string.profile__tab_activity)
  map.put("profile__tab_library", Res.string.profile__tab_library)
  map.put("profile__tab_lists", Res.string.profile__tab_lists)
  map.put("profile__tab_reviews", Res.string.profile__tab_reviews)
  map.put("profile__tab_stats", Res.string.profile__tab_stats)
  map.put("profile__unblock", Res.string.profile__unblock)
  map.put("profile__unfollow", Res.string.profile__unfollow)
  map.put("reactions__add", Res.string.reactions__add)
  map.put("reactions__pause", Res.string.reactions__pause)
  map.put("reactions__play", Res.string.reactions__play)
  map.put("reactions__rejected", Res.string.reactions__rejected)
  map.put("reactions__search", Res.string.reactions__search)
  map.put("region__asia", Res.string.region__asia)
  map.put("region__australia", Res.string.region__australia)
  map.put("region__brazil", Res.string.region__brazil)
  map.put("region__china", Res.string.region__china)
  map.put("region__europe", Res.string.region__europe)
  map.put("region__japan", Res.string.region__japan)
  map.put("region__korea", Res.string.region__korea)
  map.put("region__new_zealand", Res.string.region__new_zealand)
  map.put("region__north_america", Res.string.region__north_america)
  map.put("region__unknown", Res.string.region__unknown)
  map.put("region__worldwide", Res.string.region__worldwide)
  map.put("report__note", Res.string.report__note)
  map.put("report__reason_harassment", Res.string.report__reason_harassment)
  map.put("report__reason_hate", Res.string.report__reason_hate)
  map.put("report__reason_impersonation", Res.string.report__reason_impersonation)
  map.put("report__reason_inappropriate", Res.string.report__reason_inappropriate)
  map.put("report__reason_other", Res.string.report__reason_other)
  map.put("report__reason_spam", Res.string.report__reason_spam)
  map.put("report__reason_spoiler", Res.string.report__reason_spoiler)
  map.put("report__send", Res.string.report__send)
  map.put("report__sent", Res.string.report__sent)
  map.put("report__title", Res.string.report__title)
  map.put("review__not_available", Res.string.review__not_available)
  map.put("review__title", Res.string.review__title)
  map.put("review_aspect__audio", Res.string.review_aspect__audio)
}
